module.exports = __webpack_public_path__ + "img/Hypoxia-CRC_GSE206552.f61ff3bc.png";